import { isUndefined, omitBy } from 'lodash-es';

type Defined<T> = {
  [K in keyof T]-?: Exclude<T[K], undefined>;
};

export function omitUndefined<T extends object>(params: T): Defined<T> {
  return omitBy(params, isUndefined) as Defined<T>;
}
